import React, { useContext } from 'react';
import './AboutBanner.scss';
import { Link } from 'react-router-dom';
import bannerOne from '../../assets/newmonaassets/image_about_us_2.jpg'
import bannerTwo from '../../assets/newmonaassets/image_about_us_3.jpg'
import pattern from '../../assets/banner/pattern.png'
import { LanguageContext } from '../../context/LanguageContext';

const AboutBanner = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className='about-section' data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="about-banner-text">
                                    <h1>{t('about.sectionTitle')}</h1>
                                    <p>{t('about.description')}</p>

                                    <div className="theme-btn">
                                        <Link to='/contact'>{t('navbar.contact')}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-banner-img">
                                    <img src={bannerOne} alt={t('altText.banner')}/>
                                    <img src={bannerTwo} alt={t('altText.banner')}/>
                                    <img className='pattern' src={pattern} alt={t('altText.pattern')}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;